import { connect } from 'react-redux';

import { actionCreators as actions } from 'dux/usersManagement';
import getUsersManagementState from 'dux/usersManagement/selectors';

import InviteUserCardForm from './InviteUserCardForm';

const mapStateToProps = (state) => ({
  ...getUsersManagementState(state),
});

const mapDispatchToProps = {
  createUserInvite: actions.createUserInvite,
};

export default connect(mapStateToProps, mapDispatchToProps)(InviteUserCardForm);
